
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.005 0v10h-12L0 5l5.005-5h12zm-1 1H5.493l-4.01 4 4.01 4h10.512V1z"}})])
          )
        }
      }
    